var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFold3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 39.0001C34 35.6861 29.522 33.0001 24 33.0001C18.478 33.0001 14 35.6861 14 39.0001M42 33.0001C42 30.5401 39.532 28.4261 36 27.5001M6 33.0001C6 30.5401 8.468 28.4261 12 27.5001M36 19.4721C36.5925 18.9482 37.0756 18.3124 37.4216 17.6013C37.7675 16.8901 37.9694 16.1175 38.0157 15.328C38.062 14.5385 37.9517 13.7476 37.6913 13.0008C37.4308 12.2541 37.0253 11.5662 36.4981 10.9767C35.9708 10.3873 35.3322 9.90786 34.619 9.56606C33.9058 9.22427 33.1321 9.02685 32.3423 8.98515C31.5526 8.94345 30.7624 9.0583 30.0171 9.32309C29.2719 9.58788 28.5864 9.99739 28 10.5281M12 19.4721C10.8246 18.4083 10.1179 16.9227 10.0343 15.3397C9.95075 13.7566 10.4971 12.2048 11.5539 11.0232C12.6108 9.84167 14.0923 9.12637 15.6748 9.03359C17.2574 8.94081 18.8123 9.47808 20 10.5281M24 27.0001C22.4087 27.0001 20.8826 26.3679 19.7574 25.2427C18.6321 24.1175 18 22.5914 18 21.0001C18 19.4088 18.6321 17.8826 19.7574 16.7574C20.8826 15.6322 22.4087 15.0001 24 15.0001C25.5913 15.0001 27.1174 15.6322 28.2426 16.7574C29.3679 17.8826 30 19.4088 30 21.0001C30 22.5914 29.3679 24.1175 28.2426 25.2427C27.1174 26.3679 25.5913 27.0001 24 27.0001Z",
    stroke: "#008CB7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFold3);
export default __webpack_public_path__ + "static/media/fold3.15df1a229b977251d30958651361f9e9.svg";
export { ForwardRef as ReactComponent };